import checkoutFragment from './fragmentCheckout.gql';

const checkoutRetrieve = (
	`query ($id: ID!) {
	  node(id: $id) {
	  	id
	  	... on Checkout ${checkoutFragment}
	  }
	}`
);

export default checkoutRetrieve;
